import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import User from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/User";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { LazoLoginResponse } from "@/types/LazoLoginResponse";
import { LoginOneTimeCodeExchangeDTO } from "@/types/LoginOneTimeCodeExchangeDTO";

class LazoAuthService {
  private path: string;

  constructor(path: string) {
    this.path = path;
  }

  getRedirectUrl(userExternalId: string, token: string): Promise<ApiResponseV2<LazoLoginResponse>> {
    return HttpClientV2.post(`${this.path}/redirect-url`, { userExternalId, token });
  }

  validateLogin(email: string, password: string): Promise<ApiResponseV2<LazoLoginResponse>> {
    return HttpClientV2.post(`${this.path}/login`, { email, password });
  }

  workspaceRedirect(token: string, expiresAt: Date): Promise<ApiResponseV2<LazoLoginResponse>> {
    return HttpClientV2.post(`${this.path}/workspace-redirect`, { token, expiresAt });
  }

  requestMagicLink(email: string, redirect?: string): Promise<ApiResponseV2<void>> {
    return HttpClientV2.post(`${this.path}/request-magic-link`, { email, redirect });
  }

  exchangeOTC(otc: string): Promise<ApiResponseV2<LoginOneTimeCodeExchangeDTO>> {
    return HttpClientV2.post(`${this.path}/otc`, { otc });
  }

  getUserByToken(token: string): Promise<ApiResponseV2<User>> {
    return HttpClientV2.get(`${this.path}/user/token?t=${token}`, {
      axiosConfig: {
        timeout: 25000,
      },
    });
  }
}

export default new LazoAuthService("/api/lazo-auth");
